//Product default selection(first size) has been removed and also added the validation check
  const urlParams = new URLSearchParams(window.location.search);
  
  const variants = JSON.parse(document.querySelector('script[data-variant-picker-variants]')?.textContent ?? '{}');
  
  function isMobile() {
    if (typeof window === 'undefined' || !window.matchMedia) {
      return false;
    }

    const byWidth = window.matchMedia('(max-width: 767px)').matches;
    const byPointer = window.matchMedia('(pointer: coarse)').matches;

    return byWidth || byPointer;
  }
  
  function selectVariant(index) {
    const valueLabel = document.getElementById("value_label");
    const labelElement = valueLabel ? valueLabel.getElementsByClassName("productVariant__pill") : [];
    const formButton = document.getElementById("formButton");
    if (!labelElement[index] || !formButton) {
      return;
    }
    const buttonsInForm = formButton.getElementsByClassName("button-validation");
    labelElement[index].classList.add("selected");
    const errorDiv = document.getElementById("sizeError");
  
    const valueLabelMob = document.getElementById("value_label_mobile");
    const labelElementMob = valueLabelMob.getElementsByClassName("productVariant__pill");
  
    for(let i = 0; i < labelElementMob.length; i++) {
      labelElementMob[i].classList.remove("selected");
    }
    labelElementMob[index].classList.add("selected");
  
    buttonsInForm[0].setAttribute('type', 'submit');
  
    errorDiv.innerHTML = "";
    let indexArray = [];
    for (let i = 0; i < labelElement.length; i++) {
      if(labelElement[i].getAttribute("no-available") === null && indexArray.length < 1){
        indexArray.push(i);
      }
    }
  
    if(window.location.href.includes("products")){
      updateURLParameter(indexArray, index);
    }
  }
  
  function updateURLParameter(array, index) {
    const urlParams = new URLSearchParams(window.location.search);
    const variants = JSON.parse(document.querySelector('script[data-variant-picker-variants]').textContent);
    if (!urlParams.get('variant') && array[0] == index) {
      const queryString = new URL(window.location.href);
      queryString.searchParams.append('variant', variants[index].id);
      history.pushState(null, '', queryString.href);
    }
  }
  
  function findPosition(obj) {
      let currenttop = -300;
      if (obj && obj.offsetParent) {
          do {
              currenttop += obj.offsetTop;
          } while ((obj = obj.offsetParent));
          return currenttop;
      }
      return 0; // Return a default value if obj is null
  }
  
  let isBackDropListenerAdded = false
  function handleBackDropClick() {
    // Attach once - the anonymous listener was never removed, so it stacked up on every open.
    const backdropElem = document.getElementsByClassName('common__backdrop')[0]
    if (isBackDropListenerAdded || !backdropElem) return
    backdropElem.addEventListener('click', () => {
      toggleMobileVariantSelection()
    })
    isBackDropListenerAdded = true
  }
  
  function updateNoAvailaibleMobileOptions() {
    const varientContainer = document.querySelectorAll('.productVariant__container')[0]
    const mobileVarientContainer = document.querySelectorAll('.product__variant__picker--mobile')[0]
    if (!varientContainer || !mobileVarientContainer) return

    const varientElements = varientContainer
      .querySelectorAll('.productVariant__pills > label')
    const noAvailArray = []
  
    varientElements.length && [...varientElements].filter((el, idx) => 
        { if (el.hasAttribute('no-available')) { noAvailArray.push(idx) } }
    )
  
    const mobileVarientElements = mobileVarientContainer
        .querySelectorAll('.productVariant__pills > label')
  
    mobileVarientElements.length && [...mobileVarientElements]
    .forEach((el, index) => { if(noAvailArray.includes(index)) { el.setAttribute('no-available', true) } })
  }
  
  function toggleMobileVariantSelection(
    show = false
  ) {
    const variantSizeSelection = document.getElementsByClassName('product__variant__picker--mobile')[0]
    const mobileCartBtn = document.getElementsByClassName('mobile--cartbtn')[0]
    const backdropElem = document.getElementsByClassName('common__backdrop')[0]
  
    if(show) {
      variantSizeSelection?.classList.add('show')
      mobileCartBtn?.classList.add('mobile--cartbtn--fixed')
      backdropElem?.classList.add('show')
      handleBackDropClick()
      updateNoAvailaibleMobileOptions()
    } else {
      variantSizeSelection?.classList.remove('show')
      mobileCartBtn?.classList.remove('mobile--cartbtn--fixed')
      backdropElem?.classList.remove('show')
    }
  }
  
  function mobileSizeCartNudgeAnimation() {
    const shakeXAnimateElem = document
      .querySelectorAll('.product__variant__picker--mobile .productVariant__pills')[0]
    if (!shakeXAnimateElem) return
      
    shakeXAnimateElem.classList.add('animate__animated', 'animate__shakeX')
    
    shakeXAnimateElem.addEventListener('animationend', () => {
      shakeXAnimateElem.classList.remove('animate__animated', 'animate__shakeX')
    });
  }
  
  function buttonOnclick(index) {
      const formButton = document.getElementById("formButton");
      if (!formButton) return
      const buttonsInForm = formButton.getElementsByClassName("button-validation");
      const errorDiv = document.getElementById("sizeError");
      const mobileCartBtn = document.getElementsByClassName('mobile--cartbtn')[0]
      if (!buttonsInForm[index]) return

      if(isMobile() && buttonsInForm[index].getAttribute('type') === "button"){
          if (mobileCartBtn?.classList.contains('mobile--cartbtn--fixed')) {
            mobileSizeCartNudgeAnimation()
          }
          toggleMobileVariantSelection(true)
      } else if (buttonsInForm[index].getAttribute('type') === "button") {
          if (errorDiv) errorDiv.innerHTML = "Please select the size";
      } else if(isMobile() && buttonsInForm[index].getAttribute('type') === "submit") {
        toggleMobileVariantSelection()
      }
  }
  
  // if(urlParams.get('variant') != null){
  //   for(let i=0; i < variants.length; i++){
  //     if(variants[i].id == urlParams.get('variant')){
  //       selectVariant(i);
  //     }
  //   }
  // }

  document.querySelector('#value_label .productVariant__pill.selected')?.click();

  // Replay a size tapped before this deferred script loaded (the inline onclick only stored the index)
  if (window.fyvaPendingVariant != null) {
    const pendingIndex = window.fyvaPendingVariant;
    window.fyvaPendingVariant = null;
    const pendingLabel = document.getElementById('value_label')?.getElementsByClassName('productVariant__pill')[pendingIndex];
    const pendingInput = pendingLabel && document.getElementById(pendingLabel.htmlFor);
    // index.js may also have missed the native change event, so re-emit it for the variant picker
    pendingInput?.dispatchEvent(new Event('change', { bubbles: true }));
    selectVariant(pendingIndex);
  }

  document.querySelector('.gokwikBuyNow__btn')?.addEventListener("click", function () {
    // buttonOnclick(0);
    // Read the currently selected variant from the product form's hidden input
    // (kept in sync by the variant picker) instead of the URL's `variant` param,
    // since the URL may not carry a `variant=` key when the size is auto-selected
    // via option-name params (e.g. ?Size=M) or resolved server-side with no param at all.
    const selectedVariant = document.querySelector('[data-product-form-variant]')?.value;
    const isValidVariant = Array.isArray(variants) && variants.some(variant => variant?.id == selectedVariant);

    if (selectedVariant && isValidVariant) {
      onBuyNowClick(this);
    }
  });

  const mobileAddToCartListener = () => {
    const triggerDiv = document.getElementById('size-chart_btn');
    if (triggerDiv) {
      window.addEventListener('scroll', function() {
        const triggerDiv = document.getElementById('size-chart_btn');
        const targetDiv = document.getElementsByClassName('mobile--cartbtn')[0];

        if (!triggerDiv || !targetDiv) return;
        const triggerPosition = triggerDiv.getBoundingClientRect().top;
        const windowHeight = window.innerHeight;
      
        if (triggerPosition < windowHeight) {
            targetDiv.classList.add('anim-slidein')
        }
        else{
            targetDiv.classList.remove('anim-slidein')
        }
      });
    }
  }
  

  const desktopNavFixedOnScroll = () => {
    window.addEventListener('scroll', () => {
    
      const scrollTop = document.documentElement.scrollTop
    /*
       SR-INFORMATION :- when going live , swap the below lines of code.
    */
    //  scrollTop > 124
   
      if (scrollTop > 67) {
          document.getElementsByClassName('navigationMainLinks')[0]?.classList.add('navigationMainLinks--fixed')
      } else {
          document.getElementsByClassName('navigationMainLinks')[0]?.classList.remove('navigationMainLinks--fixed')
      }
    })
  }  
  
  desktopNavFixedOnScroll()  
  mobileAddToCartListener()
 
const jdgmStarRatingReviewApp = () => {
    const badgeElement = document.querySelector('.jdgm-prev-badge');
    if (badgeElement) {
        const numberOfReviews = parseInt(badgeElement?.dataset?.numberOfReviews || '0', 10);
        let reviewTxt = badgeElement?.querySelector('.jdgm-prev-badge__text--review');
        if (!reviewTxt) {
            reviewTxt = document.createElement('span');
            if (reviewTxt) {
                reviewTxt.className = 'jdgm-prev-badge__text--review';
                reviewTxt.innerHTML = `${numberOfReviews}${numberOfReviews === 1 ? '&nbsp; Review' : '&nbsp; Reviews'}`;
                badgeElement.appendChild(reviewTxt);
            }
        }

        const customSection = document.querySelector('.app__starRatingBadge');
        if (customSection && numberOfReviews === 0) {
            customSection?.classList.add('app__starRatingBadge--hide');
        }
    }
}
jdgmStarRatingReviewApp()